import { useEffect, useState } from "react";
import { adminApi } from "../lib/adminAuth";
import { formatDate } from "../lib/api";

export default function PanelDashboard({ onJumpTo }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div style={{ color: "var(--ink-3)" }}>Cargando…</div>;

  return (
    <div data-testid="panel-dashboard">
      <div className="panel-eyebrow">Resumen</div>
      <h1>
        Dashboard <span style={{ color: "var(--accent)", fontStyle: "italic" }}>·</span>{" "}
        Berenice — Sin Filtro
      </h1>

      <div className="stats-grid">
        <div className="stat-card" data-testid="stat-posts">
          <div className="label">Entradas publicadas</div>
          <div className="num">{stats.posts_count}</div>
        </div>
        <div className="stat-card" data-testid="stat-subs">
          <div className="label">Suscriptores activos</div>
          <div className="num">{stats.subs_active}</div>
        </div>
        <div className="stat-card" data-testid="stat-comments">
          <div className="label">Comentarios aprobados</div>
          <div className="num">{stats.comments_approved}</div>
          <div className="sub">{stats.comments_pending} pendientes</div>
        </div>
        <div className="stat-card" data-testid="stat-most-read">
          <div className="label">Más leída</div>
          <div className="num" style={{ fontSize: "1.05rem", lineHeight: 1.2 }}>
            {stats.most_read?.titulo || "—"}
          </div>
          <div className="sub">
            {(stats.most_read?.vistas || 0).toLocaleString("es-ES")} vistas
          </div>
        </div>
      </div>

      <div className="panel-tables">
        <div className="panel-card">
          <h3>Top 5 entradas por vistas</h3>
          <table className="panel-table" data-testid="dashboard-top5">
            <thead>
              <tr>
                <th>Título</th>
                <th>Categoría</th>
                <th>Vistas</th>
                <th>Comentarios</th>
              </tr>
            </thead>
            <tbody>
              {stats.top5.map((p) => (
                <tr key={p.slug}>
                  <td style={{ fontWeight: 500 }}>{p.titulo}</td>
                  <td style={{ color: "var(--accent)" }}>{p.categoria}</td>
                  <td>{(p.vistas || 0).toLocaleString("es-ES")}</td>
                  <td>{p.comentarios_aprobados}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="panel-card">
          <h3>
            Últimos comentarios pendientes
            {stats.pending5.length > 0 && (
              <button
                className="btn-tiny"
                style={{ marginLeft: 12 }}
                onClick={() => onJumpTo("comentarios")}
                data-testid="dashboard-go-pendientes"
              >
                Ir a moderar →
              </button>
            )}
          </h3>
          {stats.pending5.length === 0 ? (
            <p style={{ color: "var(--ink-3)" }}>No hay comentarios pendientes.</p>
          ) : (
            <table className="panel-table" data-testid="dashboard-pending5">
              <thead>
                <tr>
                  <th>Post</th>
                  <th>Nombre</th>
                  <th>Fecha</th>
                  <th>Texto</th>
                </tr>
              </thead>
              <tbody>
                {stats.pending5.map((c) => (
                  <tr key={c.id}>
                    <td style={{ fontSize: "0.84rem", color: "var(--ink-3)" }}>{c.post_slug}</td>
                    <td style={{ fontWeight: 500 }}>{c.nombre}</td>
                    <td style={{ fontSize: "0.84rem" }}>{formatDate(c.fecha)}</td>
                    <td style={{ color: "var(--ink-2)" }}>
                      {c.texto.length > 80 ? c.texto.slice(0, 80) + "…" : c.texto}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
